import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import {
  Button,
  MultiCheck,
  Message
} from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { showIntercom } from 'barnyard/utils';
import { VENDOR_UPDATE_FORM } from '../constants';

const classNamePrefix = 'Signup--Form';

const validate = (values) => {
  const errors = {};

  if (_.isEmpty(values.distributors)) {
    errors.distributors = 'Please select at least 1 distributor';
  }

  return errors;
};

class VendorInformationForm extends Component {
  render() {
    const {
      handleSubmit,
      buyerFormFields,
      error
    } = this.props;

    return (
      <form className={classNamePrefix} onSubmit={handleSubmit}>
        {
          error && (
            <Message
              color='danger'
              border={true}
              message={(
                <React.Fragment>
                  <strong><h4>{error.title}</h4></strong>
                  <p>{error.details}</p>
                </React.Fragment>
              )}
            />
          )
        }
        <Row
          gutter='md'
          gutterAxis='horizontal'
          className={`${classNamePrefix}__row ${classNamePrefix}__borderRow u-marginTop20`}
        >
          <Col span={12} className='u-marginTop5'>
            <Field
              name='distributors'
              label='Distributors (select ALL that apply)*'
              options={_.map(
                buyerFormFields.vendors.distributors,
                (pName, pKind) => ({ label: pName, value: pKind })
              )}
              format={null}
              component={MultiCheck}
            />
          </Col>
        </Row>
        <Row
          gutter='md'
          gutterAxis='horizontal'
          className={`${classNamePrefix}__row ${classNamePrefix}__borderRow u-marginTop20`}
        >
          <Col span={12} className='u-marginTop5'>
            <Field
              name='manufacturers'
              label='Manufacturers you Order Direct From (select ALL that apply)'
              options={_.map(
                buyerFormFields.vendors.manufacturers,
                (pName, pKind) => ({ label: pName, value: pKind })
              )}
              format={null}
              component={MultiCheck}
            />
          </Col>
        </Row>
        <Row
          gutter='md'
          gutterAxis='horizontal'
          className={`${classNamePrefix}__row ${classNamePrefix}__borderRow u-marginTop20`}
        >
          <Col span={12} className='u-marginTop5'>
            <Field
              name='labs'
              label='Diagnostic Labs (select ALL that apply)'
              options={_.map(
                buyerFormFields.vendors.labs,
                (pName, pKind) => ({ label: pName, value: pKind })
              )}
              format={null}
              component={MultiCheck}
            />
          </Col>
        </Row>
        <Row
          gutter='md'
          gutterAxis='horizontal'
          className={`${classNamePrefix}__row ${classNamePrefix}__borderRow u-marginTop20`}
        >
          <Col span={12} className='u-marginTop5'>
            <Field
              name='compounders'
              label='Compounding Pharmacies (select ALL that apply)'
              options={_.map(
                buyerFormFields.vendors.compounders,
                (pName, pKind) => ({ label: pName, value: pKind })
              )}
              format={null}
              component={MultiCheck}
            />
          </Col>
        </Row>
        <Row
          gutter='md'
          gutterAxis='horizontal'
          className={`${classNamePrefix}__row u-marginTop20`}
        >
          <Col span={12} className='u-marginTop5'>
            <Field
              name='miscellaneous'
              label='Miscellaneous (select ALL that apply)'
              options={_.map(
                buyerFormFields.vendors.miscellaneous,
                (pName, pKind) => ({ label: pName, value: pKind })
              )}
              format={null}
              component={MultiCheck}
            />
          </Col>
        </Row>
        <Row className={`${classNamePrefix}__buttons`} gutter='md' justify='edges'>
          <Col>
            <Button
              color='primary'
              naked={true}
              onClick={showIntercom}
              type='button'
              className='u-padding0'
            >
              Need Help? Let&apos;s Chat!
            </Button>
          </Col>
          <Col xs={12} md={6}>
            <Button
              className='button'
              color='primary'
              type="submit"
              full={true}
            >
              Update Vendor Information
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}

VendorInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  buyerFormFields: PropTypes.object.isRequired,
  error: PropTypes.object
};

export default reduxForm({
  form: VENDOR_UPDATE_FORM,
  validate
})(VendorInformationForm);
